"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=diagnosis.dto.js.map